import { kebabCase } from 'lodash';

// same as scripts/backstop/index.js so make sure to change it there too if you make any changes
const convertSampleName = (name: string) => {
  return kebabCase(name.toLowerCase().replace(/[.,/#!$%^&*;:{}=_`~]/g, ''));
};

export default convertSampleName;
